<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      title: 'Carriers',
      breadcrumb: {
        name: 'Carriers',
        route: { name: 'manage-carriers' }
      }
    }
  }
}
</script>
